<template>
  <div class="support-tab">
    <h3>Deal supports</h3>
    <h5>
      The Gabonese government has delivered multiple reforms to facilitate
      foreign investment. Updates to regulations on foreign ownership,
      reparation of capital and the introduction of wide ranging tax incentives
      make Gabon a investment-friendly destination.
    </h5>
    <h5>
      The deal room is led by government of Gabon and delivered and supported by
      private firms. This partnership is uniquely positioned to walk you through
      a very inviting investing environment.
    </h5>
  </div>
</template>

<script>
export default {
  name: "support-tab",
};
</script>

<style lang="scss" scoped>
.support-tab {
  color: #fff;
  text-align: center;
  padding-bottom: 150px;
  h3 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 27px;
  }
  h5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 30px;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
